import React from 'react';
import SvgIcon, {
  SvgIconProps,
} from '@mui/material/SvgIcon';

export default function ChargeMaster(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.66731 8.66659H5.66731M10.334 8.66659H14.334M8.00064 4.66659V13.9999M8.00064 4.66659C8.92112 4.66659 9.66731 3.92039 9.66731 2.99992M8.00064 4.66659C7.08017 4.66659 6.33397 3.92039 6.33397 2.99992M2.66731 13.9999L13.334 13.9999M2.66731 2.99992L6.33397 2.99992M6.33397 2.99992C6.33397 2.07944 7.08017 1.33325 8.00064 1.33325C8.92112 1.33325 9.66731 2.07944 9.66731 2.99992M9.66731 2.99992L13.334 2.99992M5.92093 9.55749C5.6538 10.5803 4.74604 11.3333 3.66731 11.3333C2.58857 11.3333 1.68081 10.5803 1.41368 9.55749C1.39186 9.47392 1.38094 9.43213 1.37989 9.26516C1.37925 9.16282 1.41728 8.92682 1.45005 8.82986C1.50351 8.67168 1.56138 8.5824 1.67712 8.40384L3.66731 5.33325L5.6575 8.40384C5.77324 8.5824 5.8311 8.67168 5.88456 8.82986C5.91733 8.92682 5.95537 9.16282 5.95473 9.26516C5.95367 9.43213 5.94276 9.47392 5.92093 9.55749ZM14.5876 9.55749C14.3205 10.5803 13.4127 11.3333 12.334 11.3333C11.2552 11.3333 10.3475 10.5803 10.0803 9.55749C10.0585 9.47392 10.0476 9.43213 10.0466 9.26516C10.0459 9.16282 10.0839 8.92682 10.1167 8.82986C10.1702 8.67168 10.228 8.5824 10.3438 8.40384L12.334 5.33325L14.3242 8.40384C14.4399 8.5824 14.4978 8.67168 14.5512 8.82986C14.584 8.92682 14.622 9.16282 14.6214 9.26516C14.6203 9.43213 14.6094 9.47392 14.5876 9.55749Z"
        stroke="currentColor"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}
